<div class="modal-container">
  <button
    id="modalDatosAdicionales"
    #modalDatosAdicionales
    data-bs-toggle="modal"
    data-bs-target="#modalAlerta2"
    hidden="hidden"
    hidden
  aria-hidden="true"
  tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAlerta2"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content modal-content-govco">
        <div class="p-2 pt-4"></div>
        <div class="modal-body modal-body-govco">
          <div class="p-2">
            <div *ngIf="primerInicioSesion && !openConfigCuenta">
              <div class="d-flex flex-row align-items-center">
                <img
                  src="../../../../assets/img/file-alt.svg"
                  alt="logo"
                  class="img-ico-form me-2" />
                <h2 class="mb-0">{{ "registry.crear_usuario" | translate }}</h2>
              </div>

              <div class="text-justify mt-2">
                <p class="my-1">{{ "registry.informacion-estadistica" | translate }}</p>
              </div>
              <div class="alert alert-primary my-1" role="alert">
                <h5 class="text-center">
                  {{"registry.informacion"| translate}}
                </h5>
              </div>
            </div>
          <app-form
            [title]="openConfigCuenta ? modalText['datos-adicionales']:''"
            [sumbitButtonText]="modalText['boton']"
            [fields]="allFields"
            (submitAction)="onSubmitPersona($event)"
            (changeAction)="onSubmitFormulario($event)"
            [edadMinima]="edadMinima">
          </app-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="openModalAbogado && primerInicioSesion">
  <app-modal-datos-adicionales-abogado [openConfigCuenta]="false"></app-modal-datos-adicionales-abogado>
</div>